import { createFeatureSelector, createSelector } from '@ngrx/store';
import { JournalEntryReducer } from '../reducers';

export const selectJournalEntryFeature = createFeatureSelector<JournalEntryReducer.JournalEntryState>(JournalEntryReducer.featureName);

export const selectJournalEntry = createSelector(selectJournalEntryFeature, (state: JournalEntryReducer.JournalEntryState) => state.item);
